/* Tree View */
import {
  ComboBoxModel,
  TreeViewItemModel
} from "@genexus/chameleon-controls-library";

/* References Types*/
import { ObjectData, SelectorCategoryData } from "./references";
import { ReferenceData } from "./references";
import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";

/**
 * @description This function converts SelectorCategoryData[] SuggestData
 */

const convertToTreeItem = (item: ReferenceData): TreeViewItemModel => ({
  caption: item.name,
  id: item.id,
  items: (item.items ?? []).map(convertToTreeItem),
  lazy: item.hasChildren && (item.items == null || item.items.length === 0),
  leaf: item.hasChildren === false,
  startImgSrc: item.icon
});

/**
 * @description This function converts ReferenceData[] data to TreeItemData[]
 */
export const convertReferenceDataToTreeViewData = (
  referenceData: ReferenceData[] | undefined
): TreeViewItemModel[] => {
  const treeData: TreeViewItemModel[] = [];
  if (!referenceData) {
    return treeData;
  }

  referenceData.forEach(item => {
    treeData.push(convertToTreeItem(item));
  });
  return treeData;
};

export const mapObjectDataToComboBoxItemModel = (
  options: ObjectData[]
): ComboBoxModel => {
  return options.map(option => {
    return {
      value: option.id,
      caption: option.name,
      startImgSrc: option.icon ?? ""
    };
  });
};

export const mapSelectorCategoryDataToComboBoxModel = (
  categoryData: SelectorCategoryData[]
): ComboBoxModel => {
  return categoryData.map((category: SelectorCategoryData) => {
    const mappedGroup: ComboBoxItemModel = {
      value: category.name,
      caption: category.name,
      expandable: true,
      expanded: true,
      items: category.items.map((item: ObjectData) => ({
        value: item.id,
        caption: item.description,
        startImgSrc: item.icon
      }))
    };

    return mappedGroup;
  });
};
